import { LockIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorIconSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
const cardIsTabletUpCss = "c7fop8z";
const cardDisabledCss = "c1uv8g30";
const cardHasWarningCss = "c444fw2";
const cardHasErrorCss = "crhg9u";
const cardCss = "c2zhm5r";
export const Card = forwardRef((props, ref) => {
  const {
    disabled,
    hasWarning,
    hasError,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(cardCss, {
    [cardIsTabletUpCss]: isTabletUp,
    [cardDisabledCss]: disabled,
    [cardHasWarningCss]: hasWarning,
    [cardHasErrorCss]: hasError
  }, props.className)} />;
});
const cardHeaderCss = "cn01e2g";
export const CardHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardHeaderCss, props.className)} />;
});
const cardTitleTextCss = "c1q7plaj";
export const CardTitleText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardTitleTextCss, props.className)} />;
});
const cardSubtitleCss = "c6w33la";
export const CardSubtitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardSubtitleCss, props.className)} />;
});
const warningBadgeCss = "w1dpkgk9";
const WarningBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(warningBadgeCss, props.className)} />;
});
const warningLabelBadgeCss = "whj1thk";
export const WarningLabelBadge = forwardRef((props, ref) => <WarningBadge ref={ref} {...props} className={classNames(warningLabelBadgeCss, props.className)} />);
const cardBorderBadgeCss = "c4f9bh3";
export const CardBorderBadge = forwardRef((props, ref) => <WarningBadge ref={ref} {...props} className={classNames(cardBorderBadgeCss, props.className)} />);
const cardWarningMessageCss = "c1qgveg8";
export const CardWarningMessage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardWarningMessageCss, props.className)} />;
});
const cardErrorMessageCss = "c1n6en65";
export const CardErrorMessage = forwardRef((props, ref) => <ErrorMessage ref={ref} {...props} className={classNames(cardErrorMessageCss, props.className)} />);
const cardActionsIsPhoneCss = "c1dxypb5";
const cardActionsIsTabletUpCss = "c5ef0rm";
const cardActionsCss = "ce0y4d";
export const CardActions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(cardActionsCss, {
    [cardActionsIsPhoneCss]: isPhone,
    [cardActionsIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const cardActionBaseIsPhoneCss = "c1sspbbw";
const cardActionBaseCss = "crk3uvl";
const CardActionBase = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(cardActionBaseCss, {
    [cardActionBaseIsPhoneCss]: isPhone
  }, props.className)} />;
});
const cardActionLinkCss = "c8qv18t";
export const CardActionLink = forwardRef((props, ref) => {
  const as = ({
    children,
    ...buttonProps
  }) => <MinimalButton {...buttonProps}>
      {children}
    </MinimalButton>;
  return <CardActionBase ref={ref} {...props} as={as} className={classNames(cardActionLinkCss, props.className)} />;
});
const cardSubAreaCss = "ct2xx6g";
export const CardSubArea = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardSubAreaCss, props.className)} />;
});
const cardLockIconCss = "cqdpmw4";
export const CardLockIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardLockIconCss, props.className)}>
      <LockIcon size="large" color={colorIconSecondary} />
    </Component>;
});

require("./panel_card.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./panel_card.js");